:host {
  display: block;
}

a {
  text-decoration: none;
}

img {
  width: 100%;
}
